<template>
    <figure ref="figure">
        <svg v-if="figureHeight > 0 && figureWidth > 0" :viewBox="`0 0 ${figureWidth} ${figureHeight}`">
            <!-- Outer width -->
            <SizeArrow
                v-if="markers"
                class="label"
                :from="{ x: horizontalPadding, y: verticalPadding }"
                :to="{ x: width - horizontalPadding, y: verticalPadding }"
                :spacing="20"
                :spacingDirection="'top'"
                color="orange"
                :value="caddy.width"
                @input="e => (caddy.width = e)"
            />
            <!-- Outer height -->
            <SizeArrow
                v-if="markers"
                class="label"
                :from="{ x: horizontalPadding, y: verticalPadding }"
                :to="{ x: horizontalPadding, y: height - verticalPadding }"
                :spacing="80"
                :spacingDirection="'left'"
                color="orange"
                :value="caddy.height"
                @input="e => (caddy.height = e)"
            />
            <!-- outer -->
            <rect
                :x="horizontalPadding"
                :y="verticalPadding"
                :width="width - horizontalPadding * 2"
                :height="height - verticalPadding * 2"
                stroke="orange"
                fill="orange"
            />

            <!-- Inner height -->
            <SizeArrow
                v-if="markers"
                class="label"
                :from="{ x: horizontalPadding + innerX, y: height - verticalPadding - innerY - innerHeight }"
                :to="{ x: horizontalPadding + innerX, y: height - verticalPadding - innerY }"
                :spacing="20 + innerX"
                :spacingDirection="'left'"
                color="green"
                :value="caddy.contentHeight"
                @input="e => (caddy.contentHeight = e)"
            />
            <!-- Inner Y -->
            <SizeArrow
                v-if="markers"
                class="label"
                :from="{ x: horizontalPadding + innerX, y: height - innerY - verticalPadding }"
                :to="{ x: horizontalPadding + innerX, y: height - verticalPadding }"
                :spacing="20 + innerX"
                :spacingDirection="'left'"
                color="green"
                :value="caddy.contentY"
                @input="e => (caddy.contentY = e)"
            />
            <!-- Inner Y2 -->
            <SizeArrow
                v-if="markers"
                class="label"
                :from="{ x: horizontalPadding + innerX, y: verticalPadding }"
                :to="{ x: horizontalPadding + innerX, y: height - innerHeight - innerY - verticalPadding }"
                :spacing="20 + innerX"
                :spacingDirection="'left'"
                color="green"
                disabled
                :value="caddy.height - caddy.contentY - caddy.contentHeight"
            />

            <!-- Inner width -->
            <SizeArrow
                v-if="markers"
                class="label"
                :from="{ x: horizontalPadding + innerX, y: height - verticalPadding - innerY }"
                :to="{ x: horizontalPadding + innerX + innerWidth, y: height - verticalPadding - innerY }"
                :spacing="20 + innerY"
                :spacingDirection="'bottom'"
                color="green"
                :value="caddy.contentWidth"
                @input="e => (caddy.contentWidth = e)"
            />

            <!-- Inner X2 -->
            <SizeArrow
                v-if="markers"
                class="label"
                :from="{ x: horizontalPadding, y: height - verticalPadding - innerY }"
                :to="{ x: horizontalPadding + innerX, y: height - verticalPadding - innerY }"
                :spacing="20 + innerY"
                :spacingDirection="'bottom'"
                color="green"
                :value="caddy.contentX"
                @input="e => (caddy.contentX = e)"
            />
            <!-- Inner X2 -->
            <SizeArrow
                v-if="markers"
                class="label"
                :from="{ x: horizontalPadding + innerX + innerWidth, y: height - verticalPadding - innerY }"
                :to="{ x: width - horizontalPadding, y: height - verticalPadding - innerY }"
                :spacing="20 + innerY"
                :spacingDirection="'bottom'"
                color="green"
                disabled
                :value="caddy.width - caddy.contentX - caddy.contentWidth"
            />
            <!-- Inner -->
            <rect
                :x="horizontalPadding + innerX"
                :y="height - innerY - verticalPadding - innerHeight"
                :width="innerWidth"
                :height="innerHeight"
                stroke="green"
                fill="green"
            />
            <!-- Ticket strip height -->
            <SizeArrow
                v-if="markers"
                class="label"
                :from="{ x: width - horizontalPadding, y: height - ticketStripHeight - verticalPadding }"
                :to="{ x: width - horizontalPadding, y: height - verticalPadding }"
                :spacing="20"
                color="blue"
                :spacingDirection="'right'"
                :value="caddy.coverHeight"
                @input="e => (caddy.coverHeight = e)"
            />
            <!-- ticket strip -->
            <rect
                :x="horizontalPadding"
                :y="height - ticketStripHeight - verticalPadding"
                :width="width - horizontalPadding * 2"
                :height="ticketStripHeight"
                stroke="blue"
                fill="blue"
            />
            <!-- Fascia height -->
            <SizeArrow
                v-if="markers"
                class="label fascia"
                :from="{ x: width - horizontalPadding, y: verticalPadding }"
                :to="{ x: width - horizontalPadding, y: height - ticketStripHeight - verticalPadding }"
                :spacing="20"
                disabled
                :value="caddy.height - caddy.coverHeight"
                :spacingDirection="'right'"
            />
            <!-- Fascia -->
            <!-- must be right next to Fascia preview for the preview to work -->
            <rect
                :x="horizontalPadding"
                :y="verticalPadding"
                :width="width - horizontalPadding * 2"
                :height="height - verticalPadding * 2 - ticketStripHeight"
                stroke="red"
                fill="red"
            />

            <Point
                v-for="(anchor, i) in caddy.clipDevices"
                :key="i"
                :x="horizontalPadding + anchor.x * widthRatio"
                :y="height - verticalPadding - anchor.y * heightRatio"
                :value="anchor"
                :markers="markers"
                :canDelete="caddy.clipDevices.length > 1"
                @delete="caddy.clipDevices = caddy.clipDevices.filter(e => e !== anchor);"
                @input="
                    v => {
                        anchor.x = v.x;
                        anchor.y = v.y;
                    }
                "
            />
        </svg>
    </figure>
</template>

<script>
import SizeArrow from "./components/size-arrow";
import Point from "./components/point";

export default {
    components: { SizeArrow, Point },
    props: {
        caddy: { type: Object, required: true },
        markers: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        figureWidth: 0,
        figureHeight: 0
    }),
    mounted() {
        const heightDelta = 50;
        const getFigureDimensions = () => {
            if (this.figureWidth !== this.$refs.figure.clientWidth) this.figureWidth = this.$refs.figure.clientWidth;
            if (this.figureHeight !== this.$refs.figure.clientHeight - heightDelta) this.figureHeight = this.$refs.figure.clientHeight - heightDelta;
        };
        this.intervalId = setInterval(getFigureDimensions, 100);
        setTimeout(getFigureDimensions, 0);
    },
    computed: {
        horizontalPadding() {
            return this.markers ? 120 : 0;
        },
        verticalPadding() {
            return this.markers ? 50 : 0;
        },
        outerHeight() {
            return this.height - this.verticalPadding * 2;
        },
        outerWidth() {
            return this.width - this.horizontalPadding * 2;
        },
        innerX() {
            return this.caddy.contentX * this.widthRatio;
        },
        innerY() {
            return this.caddy.contentY * this.heightRatio;
        },
        innerWidth() {
            return this.caddy.contentWidth * this.widthRatio;
        },
        innerHeight() {
            return this.caddy.contentHeight * this.heightRatio;
        },
        heightRatio() {
            return (1 / this.caddy.height) * this.outerHeight;
        },
        widthRatio() {
            return (1 / this.caddy.width) * this.outerWidth;
        },
        ticketStripHeight() {
            return (this.caddy.coverHeight / this.caddy.height) * this.outerHeight;
        },
        width() {
            if (this.figureWidth / this.figureHeight < this.sizeRatio) {
                return this.figureWidth;
            } else {
                return this.figureHeight * this.sizeRatio;
            }
        },
        height() {
            if (this.figureWidth / this.figureHeight < this.sizeRatio) {
                return this.figureWidth / this.sizeRatio;
            } else {
                return this.figureHeight;
            }
        },
        sizeRatio() {
            return this.caddy.width / this.caddy.height;
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    }
};
</script>

<style lang="scss" scoped>
svg *:not([fill]):not([stroke]) {
    fill: white;
}

svg > rect {
    stroke-width: 2px;
    fill-opacity: 0.1;
    transition: fill-opacity 200ms ease-out;
}

.label.fascia + rect {
    visibility: hidden;
}

.label:hover + rect,
.label:hover + .label + rect,
.label:hover + .label + .label + rect,
.label:hover + .label + .label + .label + rect,
.label:hover + .label + .label + .label + .label + rect,
.label:hover + .label + .label + .label + .label + .label + rect,
.label:focus-within + rect,
.label:focus-within + .label + rect,
.label:focus-within + .label + .label + rect,
.label:focus-within + .label + .label + .label + rect,
.label:focus-within + .label + .label + .label + .label + rect,
.label:focus-within + .label + .label + .label + .label + .label + rect,
svg > rect:hover {
    visibility: visible;
    fill-opacity: 0.2;
    stroke-width: 4px;
}
</style>



// WEBPACK FOOTER //
// caddy-preview.vue?6cdea4b9